import { useAuth } from "oidc-react";
import { useMemo } from "react";

interface ImpersonationState {
  isImpersonating: boolean;
  impersonatorUserId: string | null;
  impersonatorUserName: string | null;
  impersonatorTenantId: string | null;
  impersonatorTenantName: string | null;
}

export function useImpersonation(): ImpersonationState {
  const { userData } = useAuth();

  return useMemo(() => {
    const profile = userData?.profile;
    const impersonatorUserId = (profile?.impersonator_userid as string) ?? null;
    const impersonatorUserName =
      (profile?.impersonator_username as string) ?? null;
    const impersonatorTenantId =
      (profile?.impersonator_tenantid as string) ?? null;
    const impersonatorTenantName =
      (profile?.impersonator_tenantname as string) ?? null;

    return {
      isImpersonating: !!impersonatorUserId,
      impersonatorUserId,
      impersonatorUserName,
      impersonatorTenantId,
      impersonatorTenantName,
    };
  }, [userData]);
}
